<template>
    <div class="page_container" v-loading="loading">

        <el-table :data="tableData" border :height="tableHeight">
            <el-table-column label="编号" prop="appoint_id" align="center" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="姓名" prop="name" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="电话" prop="tel" align="center" min-width="120" show-overflow-tooltip> </el-table-column>
            <el-table-column label="微信号" prop="user_wechat" align="center" min-width="120" show-overflow-tooltip> </el-table-column>
            <el-table-column label="所属行业" prop="industry" align="center" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="公司名称" prop="company_name" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="公司规模" prop="company_size" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="预约时间" prop="create_time" align="center" min-width="145" show-overflow-tooltip></el-table-column>
          <el-table-column label="咨询信息" prop="user_inquiry" align="center" min-width="145" show-overflow-tooltip></el-table-column>
          <el-table-column label="附件" prop="file" align="center" width="90" show-overflow-tooltip>
            <template slot-scope="{row}">
              <el-button v-if="row.file"  type="text" @click="handleClickDown(row.file)">查看</el-button>
            </template>
          </el-table-column>


            <el-table-column label="🖉备注" prop="remark" align="center" min-width="120" show-overflow-tooltip>
                <template slot-scope="{row}">
                  <span  v-if="row.remark" class="theme_color remarkText" @click="handleClickRemark(row)">{{ row.remark }}</span>
                  <span  v-else class="theme_color remarkText" @click="handleClickRemark(row)">🖉</span>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pagination.pageNum"
                       :page-sizes="pagination.pageSizes"
                       :page-size="pagination.pageSize"
                       :layout="pagination.layout"
                       align="right"
                       :total="pagination.total">
        </el-pagination>
      <el-image ref="imagePreview" class="imagePreview"  :src="previewUrl"   :preview-src-list="previewList"> </el-image>
      <remarkEdit :remarkVisible.sync="remarkVisible"
                :appointId="appointId"
                :remark="remark"
                @success="getTableData"
                v-if=" remarkVisible"/>

    </div>
</template>
<script>
    import {getTableStateHeight} from '@/utils'
    import {pagination} from '@/mixins'
    import {appointList } from '@/api'
    import remarkEdit from './remarkEdit.vue'
    import {getOSSData, uploadImg} from "../../utils/uploadOss";

    export default {
        name: 'appoint',
        mixins: [pagination],
        components: {
          remarkEdit
        },
        data() {
            return {
                keyWord: '',
                tableData: [],
                tableHeight: undefined,//table高度
                loading: false,//加载动画
                resizeTimer: null, //节流定时器
                remarkVisible:false,
                appointId: 0,
                remark:'',
               previewUrl : '',
               previewList :[]
            }
        },
        mounted() {
            this.tableHeight = getTableStateHeight('page_container', 'el-form', 67)
            this.getTableData()
            window.onresize = () => {
                if (this.resizeTimer) {
                    clearTimeout(this.resizeTimer)
                }
                //开启定时器，节流函数
                this.resizeTimer = setTimeout(() => {
                    //将计算的table高度赋值给table
                    this.tableHeight = getTableStateHeight('page_container', 'el-form', 67)
                    //清除定时器
                    this.resizeTimer = null
                }, 100)
            }
        },
        methods: {
          handleClickDown(file){
            let extension = this.getFileExtension(file);
            if(extension.indexOf('jpg') > -1 || extension.indexOf('png') > -1 || extension.indexOf('jpeg') > -1 || extension.indexOf('gif') > -1){
              this.previewUrl = file
              this.previewList = [file]
              this.$refs.imagePreview.showViewer = true
            }else{
              window.open(file)
            }
          },
          getFileExtension(url) {
            // 从URL中获取文件名
            const urlObj = new URL(url);
            const filename = urlObj.pathname.split('/').pop();
            // 提取后缀名，分割点号，取最后一部分
            const extension = filename.split('.').pop();
            return extension;
          },
            getTableData() {
              this.loading = true
              appointList({
                    page: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                }).then(res => {
                    if (res.code === 200) {
                        const {
                            data,
                            total
                        } = res.data
                        this.tableData = data
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            },

            handleClickRemark(row){
              this.appointId = row.appoint_id
              this.remark = row.remark
              this.remarkVisible = true
            },



            handleSizeChange(val) {
                this.pagination.pageNum = 1
                this.pagination.pageSize = val
                this.getTableData()
            },

            handleCurrentChange(val) {
                this.pagination.pageNum = val
                this.getTableData()
            },

        },
    }
</script>
<style lang="scss" scoped>
  .remarkText{
    line-height: 42px;

  }
</style>
